export const InitialForm = {
  firstname: "",
  lastname: "",
  email: "",
  message: "",
};
